import { DebouncedSearchBox } from '@g17eco/molecules/search';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { TimeRangeSelector } from '@g17eco/molecules/time-range-selector';
import { documentOptions } from '@features/document-library/utils';
import { DateRangeType } from '@g17eco/types/common';
import { DocumentMediaType, DocumentSubType } from '@g17eco/types/document';
import { getDateRange } from '@utils/date';

export type FilterParams = {
  searchText: string;
  ownerSubType?: DocumentSubType;
  mediaTypes: DocumentMediaType[];
  dateRange: DateRangeType;
};

export const DocumentsFilters = ({
  documentFormatOptions,
  filters,
  onChangeFilters,
  onChangeTimeRange,
}: {
  documentFormatOptions: { label: string; value: DocumentMediaType }[];
  filters: FilterParams;
  onChangeFilters: (key: keyof FilterParams, value?: string | string[]) => void;
  onChangeTimeRange: (value?: DateRangeType) => void;
}) => {
  return (
    <div>
      <div className='d-flex gap-3 align-items-center mb-2'>
        <DebouncedSearchBox
          placeholder='Search for file...'
          onTextChange={(value) => onChangeFilters('searchText', value)}
          classNames={{ wrapper: 'flex-fill' }}
        />
        <TimeRangeSelector
          dateRange={filters.dateRange}
          getDateRangeFn={getDateRange}
          onChangeDateRange={(value) => onChangeTimeRange(value)}
          styleProps={{ wrapper: 'ms-2', isTransparent: true, isFlexibleSize: true }}
        />
      </div>
      <div className='row'>
        <div className='col-6'>
          <SelectFactory
            placeholder='All file types'
            selectType={SelectTypes.SingleSelect}
            options={documentOptions}
            value={documentOptions.find(({ value }) => value === filters.ownerSubType)}
            onChange={(op) => onChangeFilters('ownerSubType', op?.value)}
            isClearable={true}
          />
        </div>
        <div className='col-6'>
          <SelectFactory
            placeholder='All formats'
            selectType={SelectTypes.MultipleSelect}
            options={documentFormatOptions}
            values={filters.mediaTypes}
            onChange={(op) => onChangeFilters('mediaTypes', op)}
          />
        </div>
      </div>
    </div>
  );
};
